import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import RentalPropertyAnalyzer from './RentalPropertyAnalyzer';
import ScrollToTopOnNavigation from './components/ScrollToTopOnNavigation';
import LoginPage from './components/auth/LoginPage';
import SignupPage from './components/auth/SignupPage';
import ResetPassword from './components/auth/ResetPassword';
import CompletePasswordResetPage from './components/auth/CompletePasswordResetPage';
import AuthActionRedirect from './components/auth/AuthActionRedirect';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/auth/AdminRoute';
import AdminRoleGate from './components/auth/AdminRoleGate';
import ShareViewGate from './components/shared/ShareViewGate';
import ErrorBoundary from './components/ErrorBoundary';
import FeedbackAdminPage from './components/feedback/FeedbackAdminPage';
import ImpersonatePage from './components/admin/ImpersonatePage';
import ImpersonationBanner from './components/admin/ImpersonationBanner';
import PendingApprovalGate from './components/auth/PendingApprovalGate';
import AccountApprovalsAdminPage from './components/admin/AccountApprovalsAdminPage';
import LegalDocumentPage from './components/legal/LegalDocumentPage';
import AdminLayout from './components/admin/layout/AdminLayout';
import AdminHomePage from './components/admin/AdminHomePage';
import AdminSettingsPage from './components/admin/AdminSettingsPage';
import AdminUsersPage from './components/admin/AdminUsersPage';
import AdminUserDetailPage from './components/admin/AdminUserDetailPage';

function App() {
  return (
    <>
      <ScrollToTopOnNavigation />
      <ShareViewGate>
      <AuthActionRedirect />
      <ImpersonationBanner />
      <Routes>
        <Route
          path="/"
          element={
            <ErrorBoundary>
              <ProtectedRoute>
                <PendingApprovalGate>
                  <RentalPropertyAnalyzer />
                </PendingApprovalGate>
              </ProtectedRoute>
            </ErrorBoundary>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/terms" element={<LegalDocumentPage doc="terms" />} />
        <Route path="/privacy" element={<LegalDocumentPage doc="privacy" />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/complete-password-reset" element={<CompletePasswordResetPage />} />
        <Route
          path="/admin"
          element={
            <ErrorBoundary>
              <ProtectedRoute>
                <AdminRoute>
                  <AdminLayout />
                </AdminRoute>
              </ProtectedRoute>
            </ErrorBoundary>
          }
        >
          <Route index element={<AdminHomePage />} />
          <Route path="feedback" element={<FeedbackAdminPage />} />
          <Route path="approvals" element={<AccountApprovalsAdminPage />} />
          <Route path="account-approvals" element={<Navigate to="/admin/approvals" replace />} />
          <Route
            path="impersonate"
            element={
              <AdminRoleGate allowedRoles={['admin', 'super_admin']}>
                <ImpersonatePage />
              </AdminRoleGate>
            }
          />
          <Route path="settings" element={<AdminSettingsPage />} />
          <Route path="users" element={<AdminUsersPage />} />
          <Route path="users/:uid" element={<AdminUserDetailPage />} />
        </Route>
      </Routes>
      </ShareViewGate>
    </>
  );
}

export default App;
